import { render, staticRenderFns } from "./quick-list.vue?vue&type=template&id=70df0cc9"
import script from "./quick-list.vue?vue&type=script&lang=ts"
export * from "./quick-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports